import React, { ReactElement } from 'react';
import { SortSelect } from 'slovlex-idsk-react-components';

const PrispevokVestnikaListSort = (): ReactElement => (
  <SortSelect sortList={[
    {
      sort: 'datumZverejnenia',
      title: 'Dátum zverejnenia (od najnovších)',
      sortBy: 'desc',
    },
    {
      sort: 'datumZverejnenia',
      title: 'Dátum zverejnenia (od najstarších)',
      sortBy: 'asc',
    },
    { sort: 'nazovSort', title: 'Názov (A-Z)', sortBy: 'asc' },
    { sort: 'nazovSort', title: 'Názov (Z-A)', sortBy: 'desc' },
    { sort: 'cisloSort', title: 'Číslo (A-Z)', sortBy: 'asc' },
    { sort: 'cisloSort', title: 'Číslo (Z-A)', sortBy: 'desc' },
  ]}
  />
);

export default PrispevokVestnikaListSort;
